import { auth, functions, appCheckHeaders } from '../firebase';
import {
  LOCAL_EMULATOR_HOST,
  LOCAL_EMULATOR_PORTS,
} from '../firebaseEmulators';
import { ImageOperationCommand } from '@qkindex/contracts';

export const imageOperationUrl = (): string => {
  if (process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true') {
    return `http://${LOCAL_EMULATOR_HOST}:${LOCAL_EMULATOR_PORTS.functions}/${functions.app.options.projectId}/${process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION}/imageOperations`;
  }
  if (process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === 'true') {
    return `http://${window.location.hostname}:5001/${functions.app.options.projectId}/${process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION}/imageOperations`;
  }
  if (process.env.NODE_ENV === 'development') {
    return `https://${process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION}-${functions.app.options.projectId}.cloudfunctions.net/imageOperations`;
  }
  return '/api/image-operations';
};

export const imageOperationService = {
  async submit<T>(
    command: ImageOperationCommand,
    image?: Blob | null,
  ): Promise<T> {
    const user = auth.currentUser;
    if (!user)
      throw Object.assign(new Error('Sign in before saving.'), {
        code: 'unauthenticated',
      });
    const body = new FormData();
    body.append('command', JSON.stringify(command));
    if (image) body.append('image', image, 'image');
    const response = await fetch(imageOperationUrl(), {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${await user.getIdToken()}`,
        ...(await appCheckHeaders()),
      },
      body,
    });
    const result = await response.json().catch(() => {
      throw Object.assign(
        new Error(
          'The operation response was interrupted. Retry the same save.',
        ),
        {
          code: 'unavailable',
          details: { retryable: true },
        },
      );
    });
    if (!response.ok) {
      const error = result.error || {};
      throw Object.assign(
        new Error(error.message || 'The operation could not finish.'),
        {
          code: error.code || 'unknown',
          details: error.details,
        },
      );
    }
    return result as T;
  },
};
